"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _locale = require("date-fns/locale");
var _components = require("../components");
var _ChipFilterPopup = _interopRequireDefault(require("./ChipFilterPopup"));
var _ChipDateRangePopup = require("./ChipDateRangePopup.hooks");
var _ChipDateRangePopup2 = _interopRequireDefault(require("./ChipDateRangePopup"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ChipFilter(_ref) {
  var label = _ref.label,
    name = _ref.name,
    value = _ref.value,
    type = _ref.type,
    options = _ref.options,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? _locale.es : _ref$locale,
    onUpdate = _ref.onUpdate;
  var theme = (0, _material.useTheme)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    popup = _useState4[0],
    setPopup = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    valueLabel = _useState6[0],
    setValueLabel = _useState6[1];
  var onClick = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setPopup(type === 'date' ? 'date' : 'regular');
  }, [type]);
  var onClose = (0, _react.useCallback)(function () {
    setAnchorEl(null);
    setPopup(undefined);
  }, []);
  (0, _react.useEffect)(function () {
    var _a, _b;
    if (options) {
      setValueLabel((_b = (_a = options.find(function (el) {
        return el.value === value;
      })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value);
    } else if (_ChipDateRangePopup.FILTER_DATE_RANGE_REGEX.test(value)) {
      var dates = (0, _ChipDateRangePopup.parseQueryStringDate)(value);
      if (dates) {
        setValueLabel((0, _ChipDateRangePopup.formatDateForChip)(locale, dates.startDate, dates.endDate));
      } else {
        setValueLabel('');
      }
    } else {
      setValueLabel(value);
    }
  }, [value, options, locale]);
  var onUpdatedFilter = (0, _react.useCallback)(function (data) {
    onClose();
    onUpdate(name, data);
  }, [name, onClose, onUpdate]);
  var onDelete = (0, _react.useCallback)(function () {
    onUpdate(name, {});
  }, [name, onUpdate]);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Chip, {
    color: "default",
    size: "small",
    variant: "outlined",
    icon: value === undefined ? /*#__PURE__*/_react["default"].createElement(_components.AddCircleIcon, null) : /*#__PURE__*/_react["default"].createElement(_components.CaretDownIcon, null),
    onClick: onClick,
    deleteIcon: value === undefined ? undefined : (/*#__PURE__*/_react["default"].createElement(_components.RemoveCircleIcon, {
      color: "secondary"
    })),
    onDelete: value === undefined ? undefined : onDelete,
    label: /*#__PURE__*/_react["default"].createElement(_material.Stack, {
      direction: "row",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2"
    }, label), value !== undefined && (/*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Divider, {
      orientation: "vertical",
      sx: {
        backgroundColor: theme.palette.grey[100],
        height: theme.spacing(2),
        width: '2px',
        mx: 1
      }
    }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      variant: "body2",
      color: theme.palette.success.main,
      fontWeight: "bold"
    }, valueLabel !== null && valueLabel !== void 0 ? valueLabel : ''))))
  }), anchorEl && popup === 'regular' && (/*#__PURE__*/_react["default"].createElement(_ChipFilterPopup["default"], {
    label: label,
    name: name,
    value: value,
    type: type,
    options: options,
    anchorEl: anchorEl,
    onUpdate: onUpdatedFilter,
    onClose: onClose
  })), anchorEl && type === 'date' && popup === 'date' && (/*#__PURE__*/_react["default"].createElement(_ChipDateRangePopup2["default"], {
    anchorEl: anchorEl,
    name: name,
    value: value,
    locale: locale,
    onUpdate: onUpdatedFilter,
    onClose: onClose
  })));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ChipFilter);